import React from 'react';

export default class FancyCheckbox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false,
      value: '',
    };
  }

  handleChange(e) {
    const checked = !this.props.checked;
    this.setState({
      checked,
    });
    this.props.toggleSetting(this.props.setting, checked);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      checked: this.props.checked,
      value: this.props.notificationType,
    });

    this.forceUpdate();
  }

  render() {
    const { label } = this.props;
    let current;
    const { checked } = this.props;
    let checkedClass = '';
    if (checked) {
      checkedClass = 'checked';
    }

    const enabledClass = this.props.disabled ? 'disabled' : '';

    return (
      <div className={enabledClass}>
        <label className={checkedClass}>
          <input
            type="checkbox"
            disabled={this.props.disabled}
            name={this.props.preference}
            className={this.props.preference}
            onChange={this.handleChange.bind(this)}
            checked={checked}
            value={this.state.value}
          />
          {label}
        </label>
      </div>
    );
  }
}
